import * as ActionTypes from '../actions/actionTypes';

const initialState = { token: null };

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_KEYCLOAK:
      return {
        token: action.data.token
      };

    case ActionTypes.SET_KEYCLOAK_DISABLED:
      return {
        ...state
      };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/keycloak.js